/**
 * Admin Servers route segments, relative to the Admin domain. This package owns
 * the Servers URL: `serversConfig` builds its route path and nav url from these,
 * so the two can't drift apart.
 *
 * The page reads two optional params below its route: the expanded server
 * (`/admin/servers/:serverId`) and the account whose details are open
 * (`/admin/servers/:serverId/accounts/:accountId`). The app registers them as
 * element-less children of the Servers route, so moving between them keeps the
 * page mounted.
 *
 * The URL is literal: the app mounts the Admin domain at `adminRoutes.path`, and
 * the dashboard's admin feature drift test keeps it resolving to the route the
 * app registers for it. This module has no imports, so the boot-path feature
 * config can read it without loading any UI.
 */
export const SERVERS_ROUTE_PATH = 'servers';

/** Child of {@link SERVERS_ROUTE_PATH}: the expanded server. */
export const SERVERS_SERVER_ROUTE_PATH = ':serverId';

/** Child of {@link SERVERS_SERVER_ROUTE_PATH}: the account whose details are open. */
export const SERVERS_ACCOUNT_ROUTE_PATH = 'accounts/:accountId?';

/** Absolute URL of the admin Servers page. */
export const SERVERS_URL = '/admin/servers';
